import React from 'react';
import ExplorerNotice from './ExplorerNotice';
import ChoiceMultichoice from './ChoiceMultichoice';
import NumericView from './NumericView';
import DateView from './DateView';
import TextView from './TextView';

const RAW_FALLBACK =
  'Ce type de question ne peut pas être visualisé — réponses détaillées dans le tableau ci-dessous.';

const ExplorerChart = ({ breakdown, loading, error, comparePrevious, denominator, project, currentUser }) => {
  if (loading) {
    return (
      <div className="animate-pulse space-y-3" data-testid="explorer-loading">
        <div className="h-4 bg-gray-200 dark:bg-gray-800 rounded w-1/3" />
        <div className="h-40 bg-gray-200 dark:bg-gray-800 rounded" />
      </div>
    );
  }
  if (error) {
    return (
      <ExplorerNotice>Impossible de charger la décomposition de cette question.</ExplorerNotice>
    );
  }
  if (!breakdown || typeof breakdown !== 'object') {
    return (
      <ExplorerNotice>Sélectionnez une question pour afficher sa décomposition.</ExplorerNotice>
    );
  }

  switch (breakdown.answerType) {
    case 'choice':
    case 'multichoice':
      return (
        <ChoiceMultichoice
          breakdown={breakdown}
          comparePrevious={comparePrevious}
          denominator={denominator}
        />
      );
    case 'numeric':
      return <NumericView breakdown={breakdown} />;
    case 'date':
      return <DateView breakdown={breakdown} />;
    case 'text':
      return <TextView breakdown={breakdown} project={project} currentUser={currentUser} />;
    default:
      return <ExplorerNotice>{RAW_FALLBACK}</ExplorerNotice>;
  }
};

export default ExplorerChart;
